import Step1Image from "./assets/images/step1-image.svg"
import Step2Image from "./assets/images/step2-image.svg"
import Step3Image from "./assets/images/step3-image.svg"


export const steps = [
    {
        number: 1,
        title: "Create USD Wallet",
        subtitle: "Open a USD wallet from dashboard to initiate transactions.",
        imageSrc: Step1Image,
    },
    {
        number: 2,
        title: "Fund USD Account",
        subtitle: "Transfer the funds into your USD wallet.",
        imageSrc:
        Step2Image,
    },
    {
        number: 3,
        title: "Transfer to China",
        subtitle: "Send funds from USD to any China accounts.",
        imageSrc:
        Step3Image,
    },
]